module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("ePopr"))).then(() => parcelRequire('9Lwss'));